import { MarketingService } from "./../../services/marketing/marketing.service";
import { UserServiceService } from "./../../services/user-service/user-service.service";
import { environment } from "./../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { ErrorHandlerService } from "./../../services/shared/error-handler.service";
import { ProjectsService } from "./../../services/projects/projects.service";
import { LeadsService } from "./../../services/lead-service/lead-service.service";
import { ActivatedRoute } from "@angular/router";
import {
  Renderer2,
  Component,
  OnInit,
  ViewContainerRef,
  ChangeDetectorRef,
} from "@angular/core";
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl,
} from "@angular/forms";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { ReservationService } from "../../services/reservation-service/reservation.service";
import { Reservation } from "../../dtos/reservation.viewmodel";
import swal from "sweetalert2";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { Observable } from "rxjs/Observable";
import { HoldService } from "../../hold-module/hold.service";
import { EoiService } from "../../services/eoi/eoi.service";
import { AccountsService } from "../../services/settings-service/accounts/accounts.service";
import { addDays, addMonths, format, isValid, parseISO, startOfDay } from "date-fns";
import { OcrService } from "../../services/ocr/ocr.service";
import { OcrRecord } from "../../models/ocr.model";

interface DownPaymentEntry {
  down_payment_type: string | null;
  down_payment: number | null;
  down_payment_interval: string | null;
}

@Component({
  selector: "addreservation",
  templateUrl: "./addreservation.component.html",
  styleUrls: ["./addreservation.component.css"],
  providers: [ReservationService],
})
export class AddreservationComponent implements OnInit {
  documentForm: FormGroup;
  reservation: Reservation;
  showError: boolean;
  messages: any;
  leadphonenumber: string;
  sub: any;
  unitId: any;
  isHold;
  eoi_id;
  project_id;
  leads: any;
  leadsArrayString: any = [];
  chosenLead: any;

  ocrMessage: string = null;
  ocrMessageSeverity = "warning";
  ocrLookupBusy = false;
  ocrUncertainFields: string[] = [];
  loadingData: boolean = false;
  arrSearch: any = [];
  dataFromSearch: any;
  unit_serial: any;
  blockTimer: any;
  disabledSubmitWhileSending: boolean = false;
  deal_types: any = ["Direct", "In-Direct"];
  direct_option: any = ["Individual"];
  ambassadors: any;
  brokers: any;
  partner_brokers: any[] = [];
  deal_type: any;
  // methods: any = ['7 Years 15perc DP and 85perc over 25 ins WWNC', '6 Years 10perc DP and 90perc over 22 ins WWNC', '5 Years 5perc DP and 95perc over 19 ins WWNC', '6 years', '6 years overseas', '7.5 years', '7.5 years cityscape', '7.5 years overseas','New Homes- 5perc DP, 5perc After 6 Month, 25 Equal Inst'];
  methods: any;
  commercial_methods: any;
  payment_plan_id: any;
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  project_type: any;
  rent_types: any;
  sale_types: any;
  payment_type: any;
  is_overseas: any;
  reservation_fees: any;
  type: any;

  ready_to_add_contract_sale: boolean = true;
  ready_to_add_contract_rent: boolean = false;
  unit_details: any;

  is_residence: any = 1;

  current_selected_user: any;
  holdId;
  agents: Array<any> = [];

  selectedLead: any = null;
  leadTypeaheadInitial: any = null;
  selectedUnit: any = null;
  unitTypeaheadInitial: any = null;
  eoisArr: any;
  allowedRoles: string[] = [];
  isRoleAllowed: boolean;
  periodMeterPrice: string;
  special_payments: any = [];
  special_payment = {
    special_payment_type: "percentage",
    special_payment_value: null,
    special_payment_count: null,
    special_payment_interval: "12",
    special_payment_date: null,
  };
  firstInstallmentDayIncrement: number = 0;
  down_payments_array: DownPaymentEntry[] = [];
  private defaultDownPaymentInterval = "3";
  private defaultDownPayment: DownPaymentEntry = {
    down_payment_type: null,
    down_payment: null,
    down_payment_interval: null,
  };
  private readonly defaultTempBlockTimeSeconds = 15 * 60;
  private tempBlockTimeSeconds = this.defaultTempBlockTimeSeconds;
  reserveData: any;
  panelOpenState: boolean = false;
  banks: any[] = [];
  paymentMethods: any[] = [
    { id: 1, name: "Cash (نقدًا)" },
    { id: 3, name: "Transfer (تحويل)" },
    { id: 4, name: "Cheque (شيك)" },
  ];

  constructor(
    private addReservation: ReservationService,
    private fb: FormBuilder,
    private router: Router,
    private cookieService: CookieService,
    vRef: ViewContainerRef,
    private leadsService: LeadsService,
    private slimLoadingBarService: SlimLoadingBarService,
    public route: ActivatedRoute,
    public projectService: ProjectsService,
    private marketingService: MarketingService,
    public errorHandlerService: ErrorHandlerService,
    public renderer2: Renderer2,
    public http: HttpClient,
    private userService: UserServiceService,
    private holdService: HoldService,
    private eoiService: EoiService,
    private cdr: ChangeDetectorRef,
    private accountService: AccountsService
  ,
    private ocrService: OcrService
  ) {
    this.createForm();
    this.reservation = new Reservation();
    this.sub = this.route.params.subscribe((params) => {
      console.log("paramas", params);

      this.unitId = +params["id"];

      route.queryParams.subscribe((p) => {
        console.log(p.hold);
        this.isHold = p.hold;
        this.eoi_id = p.eoi_id;
        let eoiId = p.eoiId;
        if (this.unitId > 0 && this.isHold) {
          console.log("from hold");
          console.log("is hold", this.isHold);
          this.holdId = this.unitId;
          holdService.getHold(this.holdId).subscribe((res: any) => {
            console.log("this is the hold data", res);
            this.unit_details = res.unit;
            this.unit_serial = res.unit.serial;
            this.documentForm.patchValue({
              unit_id: res.unit.id,
              unit_building: res.unit.building_id || "",
              unit_phase: res.phase || "",
              unit_land_area: res.unit.land_area || "",
              unit_building_area: res.unit.build_area || "",
              unit_basement_area: res.unit.basement_area || "",
              unit_uncovered_basement_area:
                res.unit.basement_uncovered_area || "",
              unit_roof_area: res.unit.roof_area || "",
              unit_semi_covered_roof_area: res.unit.uncovered_roof_area || "",
              unit_penthouse_area: res.unit.penthouse_area || "",
              unit_garden_area: res.unit.garden_area || "",
              finishing_type_id: res.finishing_type_id || "",
              unit_price: res.unit_price || res.unit.unit_price || "",
              unit_garden_price: res.unit.garden_price || "",
              unit_garage_area: res.unit.garage_area || "",
              unit_garage_slots: 1,
              storage_slots: "",
              extra_outdoor_meters: "",
              service_room_slots: "",
              service_room_with_bathroom_slots: "",
              unit_extra_area: res.unit.extra_area || "",
              unit_extra_price: res.unit.extra_price || "",
              unit_maintenance_price: res.unit.maintenance_fees || "",
              unit_location: res.unit.location || "",
              reservation_fees: "",
              // installment_fees: res.unit.installment || "",
              installment_Years: "",
              project_type: "Residential",
              contract_type: "sale",
              lead_id: res.lead_id,
              lead_name: res.lead_name,
              lead_address: res.lead_address,
              occupation: res.job_title,
              lead_home_phone: res.lead_home_phone,
              lead_phone: res.lead_phone,
              lead_district: res.lead_district,
              lead_other_phone: res.lead_other_phone,
              lead_nationality: res.lead_nationality,
              lead_birthday: res.lead_birthday,
              lead_email: res.lead_email,
              lead_work_address: res.lead_work_address,
              lead_id_address: res.lead_id_address,
              lead_national_id: res.lead_national_id,
              lead_issued_dy: res.lead_issued_dy,
              lead_issued_date: res.national_issue_date,
              lead_is_residence: res.lead.is_residence,
              // deal_type: element.lead_channel.name,
              deal_type: res.deal_type || null,
              lead_source: res.lead_source,
              ambassador_id: res.ambassador_id,
              user_id: res.user_id,
              broker_id: res.broker_id,
              broker_incentive_id: res.broker_incentive_id || "",
              partner_broker_id:
                res.unit &&
                res.unit.project &&
                res.unit.project.partner_broker_id
                  ? res.unit.project.partner_broker_id
                  : "",
              is_overseas: res.is_overseas,
            });
            this.patchUnitMetaFields(res.unit);
            setTimeout(() => {
              this.documentForm.patchValue({
                lead_code: res.lead.code,
                lead_home_code: res.lead.code_2,
                lead_other_code: res.lead.code_3,
                lead_phone_without_code: res.lead.phone_without_code,
                lead_home_phone_without_code: res.lead.phone_2_without_code,
                lead_other_phone_without_code: res.lead.phone_3_without_code,
              })
            }, 500);
          });
        } else if (eoiId) {
          this.loadFromEoi(eoiId);
        }
      });

      if (this.unitId > 0 && !this.isHold) {
        this.loadUnitById(this.unitId);
      }
    });
  }

  getLeads() {
    // this.getAllLeads();
  }

  getAllowedRoles() {
    this.accountService.getMortageControlsRoles().subscribe(
      (data: any) => {
        this.allowedRoles = data.allowedRoles;
        let role = this.userProfile.role;
        this.isRoleAllowed = this.allowedRoles.includes(role);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  addSpecialPayment() {
    this.special_payments.push({ ...this.special_payment });
    this.special_payment = {
      special_payment_type: "percentage",
      special_payment_value: null,
      special_payment_count: null,
      special_payment_interval: "12",
      special_payment_date: null,
    };
    console.log(this.special_payments);
  }

  deleteSpecialPayment(index) {
    this.special_payments.splice(index, 1);
  }

  getAgents() {
    this.slimLoadingBarService.start();
    this.agents = null;
    this.leadsService.getAgents().subscribe(
      (data: any) => {
        this.agents = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  search_unit_id = "";
  unitsArr = [];
  searchUnits(keyword) {
    if (keyword) {
      return this.projectService
        .filterAllUnitsByKeywordForEOI(this.project_id, {
          keyword,
        })
        .map((res: any) => {
          console.log(res.data.length);
          if (res.data.length == 0) {
            let arr = [];
            return arr;
          } else {
            this.unitsArr = [];
            this.dataFromSearch = res.data;
            res.data.forEach((e) => {
              this.unitsArr.push(`${ e.serial } / ${ e.id }`);
            });
            // console.log(arr);
            return this.unitsArr;
          }
        });
    } else {
      return Observable.of([]);
    }
  }

  selectUnitInDropDown() {
    if (this.search_unit_id.indexOf(" / ") != -1) {
      let unit_data = this.search_unit_id.split(" / ");
      this.unitId = unit_data[unit_data.length - 1];
      this.loadUnitById(this.unitId);
    }
  }

  loadUnitById(id) {
    this.slimLoadingBarService.start();
    this.projectService.getCurrentUnit(id).subscribe(
      (data: any) => {
        this.project_type = data.project.type || "Commercial";
        console.log(data);
        this.blockTimer = data.remaining_temp_block_seconds || 0;
        if (data.remaining_temp_block_seconds == 0) this.blocktimeEnd();
        const remainingTempBlockSeconds = Number(
          data.remaining_temp_block_seconds
        );
        const hasRemainingTempBlockSeconds = Number.isFinite(
          remainingTempBlockSeconds
        );

        if (hasRemainingTempBlockSeconds && remainingTempBlockSeconds <= 0) {
          this.blockTimer = 0;
        } else if (this.tempBlockTimeSeconds > 0) {
          this.blockTimer = this.tempBlockTimeSeconds;
        } else if (hasRemainingTempBlockSeconds && remainingTempBlockSeconds > 0) {
          this.blockTimer = remainingTempBlockSeconds;
        } else {
          this.blockTimer = this.defaultTempBlockTimeSeconds;
        }
        this.unit_details = data;
        this.unit_serial = data.serial;
        this.documentForm.patchValue({
          unit_id: data.id,
          unit_building: data.building_id || "",
          unit_phase: data.phase_id || "",
          unit_land_area: data.land_area || "",
          unit_building_area: data.build_area || "",
          unit_basement_area: data.basement_area || "",
          unit_uncovered_basement_area: data.basement_uncovered_area || "",
          unit_roof_area: data.roof_area || "",
          unit_semi_covered_roof_area: data.uncovered_roof_area || "",
          unit_penthouse_area: data.penthouse_area || "",
          unit_garden_area: data.garden_area || "",
          unit_price: "",
          service_room_slots: "",
          service_room_with_bathroom_slots: "",
          unit_garden_price: data.garden_price || "",
          unit_garage_area: data.garage_area || "",
          unit_garage_slots: 1,
          storage_slots: "",
          extra_outdoor_meters: "",
          unit_extra_area: data.extra_area || "",
          unit_extra_price: data.extra_price || "",
          unit_maintenance_price: data.maintenance_fees || "",
          unit_location: data.location || "",
          reservation_fees: "",
          // installment_fees: data.installment || "",
          installment_Years: "",
          project_type: "Residential",
          contract_type: "sale",
          partner_broker_id:
            data.project && data.project.partner_broker_id
              ? data.project.partner_broker_id
              : "",
        });
        // if (data.project.type == "Commercial") {
        //   this.commercial_methods = [
        //     "rent for 3 years",
        //     "rent for 4 years",
        //     "rent for 5 years",
        //   ];
        //   this.documentForm.patchValue({
        //     contract_type: "sale",
        //   });
        // } else if (data.project.type == "Residential") {
        //   this.documentForm.patchValue({
        //     contract_type: "sale",
        //   });
        // }
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  loadFromEoi(id?) {
    this.slimLoadingBarService.start();
    this.eoiService.getEoi(id || this.eoi_id).subscribe(
      (res: any) => {
        this.project_id = res.project_id;
        this.applyLeadSelection(res.lead, true);
        this.getLeadDetails();
        if (res.unit) {
          this.applyUnitSelection(res.unit, true);
          if (res.unit.id) {
            this.unitId = res.unit.id;
            this.loadUnitById(res.unit.id);
          }
        }

        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  // getPaymentTerms() {
  //   this.userService.getAllPaymentTerms().subscribe(res => {
  //     this.methods = res;
  //   }, err => this.errorHandlerService.handleErorr(err));
  // }

  changePaymentMethod(event) {
    const planId =
      typeof event === "object" && event
        ? event.id != null
          ? event.id
          : event.value != null
          ? event.value
          : null
        : event;
    if (!Array.isArray(this.methods)) {
      return;
    }
    if (planId == null) {
      return;
    }
    const selectedPlan = this.methods.find((plan) => plan.id == planId);
    if (selectedPlan) {
      this.reservation_fees = selectedPlan.downpayment_percentage;
    }
  }

  getPaymentTermsByProjectId(project_id) {
    console.log(project_id);
    this.userService.getProjectPaymentTerms(project_id).subscribe(
      (res) => {
        let arr: any = res;
        this.methods = arr;
        console.log(this.methods);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  observableSource = (keyword: any): any => {
    let baseUrl: string = environment.api_base_url;
    let data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .get(`${ baseUrl }leads?keyword=${keyword}`)
        .map((res: any) => {
          console.log(res.data.length);
          if (res.data.length == 0) {
            let arr = [];
            return arr;
          } else {
            this.arrSearch = [];
            this.dataFromSearch = res.data;
            res.data.forEach((e) => {
              this.arrSearch.push(`${ e.name } / ${ e.id }`);
            });
            // console.log(arr);
            return this.arrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  getAllLeads() {
    this.leadsService.getLeads().subscribe(
      (data) => {
        console.log(data);
        this.convertLeads(data);
        return this.leadsArrayString;
      },
      (err) => console.log(err)
    );
  }

  convertLeads(data) {
    this.leadsArrayString = [];
    this.leads = data.data;
    this.leads.forEach((element) => {
      this.leadsArrayString.push(element.name);
    });
  }


  /**
   * Fill the identity fields from a scanned national ID, then attach the lead.
   *
   * The date controls here are native <input type="date"> and type="month",
   * which want ISO - exactly what the pipeline returns - so the birth date
   * passes through untouched and the issue date only needs truncating to
   * year-month. (The VIE build needed real conversion; PrimeNG pickers there
   * use dd-mm-yy.)
   */
  onIdScanned(record: OcrRecord): void {
    const uncertain: string[] = [];
    const self = this;

    const apply = function (controlName: string, identityKey: string, transform?: any) {
      const control = self.documentForm.get(controlName);
      if (!control) {
        return;
      }
      const raw = self.ocrService.identityValue(record, identityKey);
      if (raw === null) {
        return;
      }
      const value = transform ? transform(raw) : raw;
      if (value === null || value === "") {
        return;
      }
      control.patchValue(value);
      control.markAsDirty();
      if (self.ocrService.needsVerification(record, identityKey)) {
        uncertain.push(controlName);
      }
    };

    apply("lead_national_id", "national_number", function (raw) {
      const digits = raw.replace(/\D/g, "");
      return digits ? digits : null;
    });
    apply("lead_birthday", "birth_date");
    apply("lead_issued_date", "id_issue_date", function (raw) {
      return /^\d{4}-\d{2}/.test(raw) ? raw.substring(0, 7) : null;
    });
    apply("lead_address", "address_ar");
    apply("lead_id_address", "address_ar");
    apply("occupation", "occupation_ar");
    apply("lead_district", "governorate");
    apply("lead_arabic_name", "full_name_ar");
    apply("lead_marital_status", "marital_status");

    this.ocrUncertainFields = uncertain;
    this.ocrMessage = null;

    const critical = this.ocrService.criticalFlags(record);
    if (critical.length) {
      this.ocrMessageSeverity = "danger";
      this.ocrMessage =
        "This scan did not verify: " + critical[0] + " Check every filled field against the card.";
      return;
    }

    if (!this.chosenLead) {
      this.findLeadFromScan(record, uncertain.length);
    }
  }

  onIdScanCleared(): void {
    this.ocrMessage = null;
    this.ocrUncertainFields = [];
  }

  isOcrUncertain(controlName: string): boolean {
    return this.ocrUncertainFields.indexOf(controlName) !== -1;
  }

  private findLeadFromScan(record: OcrRecord, uncertainCount: number): void {
    const nationalNumber = this.ocrService.verifiedNationalNumber(record);
    const filledNote =
      "The card was read" +
      (uncertainCount ? " (" + uncertainCount + " field(s) highlighted for checking)." : ".");

    if (!nationalNumber) {
      this.ocrMessageSeverity = "warning";
      this.ocrMessage =
        filledNote +
        " The national number could not be confirmed, so no lead was looked up - find the lead manually.";
      return;
    }

    this.ocrLookupBusy = true;
    this.leadsService.filterLeadByName(nationalNumber).subscribe(
      (response: any) => {
        this.ocrLookupBusy = false;
        const leads = response && response.data && response.data.length ? response.data : [];

        if (leads.length === 1) {
          const lead = leads[0];
          this.dataFromSearch = leads;
          this.chosenLead = (lead.name ? lead.name : "") + " / " + lead.id;
          this.getLeadDetails();
          this.ocrMessage = null;
          return;
        }

        if (leads.length > 1) {
          this.dataFromSearch = leads;
          this.chosenLead = nationalNumber;
          this.ocrMessageSeverity = "warning";
          this.ocrMessage =
            leads.length + " leads share national number " + nationalNumber +
            " - pick the right one and press GET INFO.";
          return;
        }

        this.chosenLead = nationalNumber;
        this.ocrMessageSeverity = "warning";
        this.ocrMessage =
          filledNote + " No lead was found for national number " + nationalNumber +
          ", so none is attached - select or create the lead before saving.";
      },
      () => {
        this.ocrLookupBusy = false;
        this.ocrMessageSeverity = "danger";
        this.ocrMessage = filledNote + " The lead search failed just now - find the lead manually.";
      }
    );
  }

  getLeadDetails(): any {
    console.log(this.chosenLead);
    if (!this.chosenLead && !this.selectedLead) {
      swal("Lead name can not be empty!");
    } else {
      // Use selectedLead from new version if available, otherwise use dataFromSearch
      const element = this.selectedLead || (this.dataFromSearch.length > 0 ? this.dataFromSearch.find(e => {
        const nameArr = this.chosenLead.replace(/\s/g, "").split("/");
        const leadId = nameArr[nameArr.length - 1];
        return e.id == leadId;
      }) : null);

      if (!element.id) {
        swal("No Lead with that name.");
        return;
      }

      console.log(element);
      this.documentForm.patchValue({
        lead_id: element.id,
        lead_name: element.name,
        lead_address: element.address,
        occupation: element.job_title,
        lead_home_phone: element.phone_2,
        lead_other_phone: element.phone_3,
        lead_phone: element.phone,
        lead_district: element.district,
        lead_nationality: element.nationality,
        lead_birthday: element.date_of_birth,
        lead_email: element.email,
        lead_work_address: element.id_address,
        lead_id_address: element.id_address,
        lead_national_id:
          element.id_number != null
            ? element.id_number
            : element.national_num,
        lead_issued_dy: element.issued_by,
        lead_issued_date: element.national_issue_date,
        lead_is_residence: element.is_residence,
        // deal_type: element.lead_channel.name,
        deal_type: element.lead_channel
          ? element.lead_channel.name
          : null,
        deal_category: element.lead_channel
          ? element.lead_channel.name === "Direct"
            ? element.lead_source
            : ""
          : "",
        lead_source: element.lead_source,
        ambassador_id: element.ambassador_id,
        user_id: element.agent_id,
        broker_id: element.broker_id,
        broker_incentive_id: element.broker_incentive_id || "",
        land_area: element.land_area,
        root_area: element.root_area,
      });
      if (element.broker_id) {
        this.getIncentiveUsers(element.broker_id, element.broker_incentive_id);
      }
      setTimeout(() => {
        this.documentForm.patchValue({
          lead_code: element.code,
          lead_home_code: element.code_2,
          lead_other_code: element.code_3,
          lead_phone_without_code: element.phone_without_code,
          lead_home_phone_without_code: element.phone_2_without_code,
          lead_other_phone_without_code: element.phone_3_without_code,
        })
      }, 500);
      this.cdr.detectChanges();

      // Keep the old search logic for backward compatibility
      const keyword = this.chosenLead || element.name || "";
      if (keyword) {
        this.leadsService.filterLeadByName(keyword).subscribe(
          (data) => {
            console.log(data);
            this.convertLeads(data);
            console.log(this.leadsArrayString);
          },
          (err) => console.log(err)
        );
      }
    }
  }

  onLeadSelected(lead: any | null): void {
    this.applyLeadSelection(lead, false);
  }

  onUnitSelected(unit: any | null): void {
    this.applyUnitSelection(unit, false);
  }

  loadSelectedUnit(): void {
    if (!this.selectedUnit || !this.selectedUnit.id) {
      swal("Please select a unit first.");
      return;
    }
    this.unitId = this.selectedUnit.id;
    this.loadUnitById(this.unitId);
  }

  private applyLeadSelection(lead: any | null, syncTypeahead: boolean): void {
    this.selectedLead = lead;
    if (syncTypeahead) {
      this.leadTypeaheadInitial = lead;
    }
  }

  private applyUnitSelection(unit: any | null, syncTypeahead: boolean): void {
    this.selectedUnit = unit;
    if (syncTypeahead) {
      this.unitTypeaheadInitial = unit;
    }
    const projectId =
      unit && unit.project && unit.project.id != null
        ? unit.project.id
        : unit && unit.project_id != null
        ? unit.project_id
        : null;
    if (projectId) {
      this.project_id = projectId;
    }
    this.patchUnitMetaFields(unit);
  }

  private patchUnitMetaFields(unit: any | null): void {
    if (!this.documentForm) {
      return;
    }
    this.documentForm.patchValue({
      status: unit && unit.status != null ? unit.status : null,
      build_area: unit && unit.build_area != null ? unit.build_area : null,
    });
  }

  incentive_users: any;
  selected_incentive_broker: any;
  getIncentiveUsers(
    broker: number | { id?: number; value?: number } | null,
    broker_incentive_id?: number
  ) {
    const resolvedBrokerId =
      typeof broker === "object"
        ? broker && broker.id != null
          ? broker.id
          : broker && broker.value != null
          ? broker.value
          : null
        : broker;
    const brokerId =
      resolvedBrokerId != null
        ? resolvedBrokerId
        : this.documentForm.get("broker_id").value != null
        ? this.documentForm.get("broker_id").value
        : null;
    this.incentive_users = [];
    if (!brokerId) {
      this.documentForm.get("broker_incentive_id").setValue("");
      return;
    }
    // this.lead.broker_incentive_id = "";
    this.documentForm.get("broker_incentive_id").setValue("");
    this.userService.get_incentive_users(brokerId).subscribe(
      (res: any) => {
        const users = Array.isArray(res) ? res : [];
        this.incentive_users = users;
        if (broker_incentive_id && Array.isArray(users)) {
          const matchedUser = users.find(
            (user) => user.id == broker_incentive_id
          );
          if (matchedUser) {
            this.documentForm.get("broker_incentive_id").setValue(
              matchedUser.id
            );
          }
        }
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  receivePhone(event, phone, code, err) {
    this.documentForm.get(err).setValue(event.phoneError);
    this.documentForm.get(phone).setValue(event.phone);
    this.documentForm.get(code).setValue(event.code);
  }

  ngOnInit() {
    this.getLeads();
    this.deal_type_change();
    this.getChannels();
    this.getAmbassadors();
    this.getBrokers();
    this.getPartnerBrokers();
    this.getBanks();
    // this.getPaymentTerms();
    this.getAgents();
    this.getAllowedRoles();
    this.documentForm.get("contract_type").valueChanges.subscribe((value) => {
      this.onContractTypeChange(value);
    });
    if (this.documentForm.get("contract_type").value === "rent") {
      this.onContractTypeChange("rent");
    }
    this.route.queryParams.subscribe((res) => {
      console.log(res);
      if (res.has_reserve_data) {
        this.reserveData = JSON.parse(sessionStorage.getItem('reserveData'));
        this.reserveData.down_payments_array = JSON.parse(this.reserveData.down_payments_array);
        this.reserveData.special_payments = JSON.parse(this.reserveData.special_payments);
        console.log(this.reserveData);
        this.documentForm.patchValue({
          generator_type: this.reserveData.generator_type,
          installments_count: this.reserveData.installments_count,
          down_payment_type: this.reserveData.down_payment_type,
          amount: this.reserveData.amount,
          down_payment_interval: this.reserveData.down_payment_interval,
          interval: this.reserveData.interval,
          starting_date: this.reserveData.starting_date,
          down_payment_count: this.reserveData.down_payment_count,
          first_installment_date: this.reserveData.first_installment_date,
          status: this.reserveData.status,
          build_area: this.reserveData.build_area,
          maintenance_fees_date: this.reserveData.maintenance_fees_date,
          garage_fees_date: this.reserveData.garage_fees_date,
          cash_price: this.reserveData.cash_price
        });
        this.down_payments_array = this.reserveData.down_payments_array;
        this.special_payments = this.reserveData.special_payments;
      }

      this.projectService.getCurrentUnit(this.unitId).subscribe((data: any) => {
        if (res.finishing_type_id) {
          this.unit_details = data;
          this.onFinishTypePriceChange(res.finishing_type_id);
        }
      });
    });
  }

  valueChanged(ev) {
    this.chosenLead = ev;
    // this.searchForInputs(ev);
  }

  createForm() {
    this.documentForm = this.fb.group({
      lead_id: [0, Validators.required],
      lead_name: ["", Validators.required],
      lead_address: ["", Validators.required],
      lead_code: [null, Validators.required],
      lead_home_code: [null],
      lead_other_code: [null],
      occupation: ["", Validators.required],
      lead_home_phone: [""],
      lead_phone: ["", Validators.required],
      lead_other_phone: [""],
      lead_nationality: ["", Validators.required],
      lead_birthday: [""],
      lead_national_id: ["", Validators.required],
      lead_issued_dy: [""],
      lead_issued_date: [""],
      lead_district: ["", Validators.required],
      lead_email: [""],
      lead_work_address: [""],
      lead_id_address: [""],
      unit_id: [""],
      project_type: [""],
      unit_building: [""],
      unit_phase: [""],
      unit_land_area: [""],
      unit_building_area: [""],
      unit_basement_area: [""],
      land_area: [""],
      unit_roof_area: [""],
      roof_area: [""],
      unit_penthouse_area: [""],
      unit_garden_area: [""],
      unit_price: [""],
      unit_garden_price: [""],
      unit_garage_area: [""],
      unit_garage_slots: [1, Validators.required],
      storage_slots: [""],
      extra_outdoor_meters: [""],
      service_room_slots: ["", Validators.required],
      service_room_with_bathroom_slots: ["", Validators.required],
      unit_extra_area: [""],
      unit_extra_price: [""],
      unit_maintenance_price: [""],
      unit_location: [""],
      reservation_fees: [""],
      // installment_fees: [""],
      payment_plan_id: ["", Validators.required],
      deal_type: ["", Validators.required],
      deal_category: ["", Validators.required],
      broker_id: ["", Validators.required],
      broker_incentive_id: [""],
      partner_broker_id: [""],
      ambassador_id: ["", Validators.required],
      user_id: ["", Validators.required],
      lead_home_phone_without_code: [null],
      lead_home_phone_error: [null],
      lead_phone_without_code: [null, Validators.required],
      lead_phone_error: [null, Validators.required],
      lead_other_phone_without_code: [null],
      lead_other_phone_error: [null],
      unit_roof_price: [null],
      unit_roof_meter_price: [null],
      unit_garden_meter_price: [null],
      payment_method_id: [null, Validators.required],
      cheque_book_name: [""],
      cheque_number: [""],
      bank_id: [null],
      name_on_cheques: [""],
      due_date: [""],
      contract_type: ["sale", Validators.required],
      payment_type: ["", Validators.required],
      company_name: [""],
      company_address: [""],
      company_info: [""],
      commercial_register: [""],
      commercial_register_name: [""],
      commercial_register_address: [""],
      commercial_register_issue_date: [""],
      person_authorized_to_sign_the_contract_job: [""],
      person_authorized_to_sign_the_contract_id: [""],
      person_authorized_to_sign_the_contract_address: [""],
      person_authorized_to_sign_the_contract_name: [""],
      rent_value: [""],
      rent_start_date: [""],
      rent_end_date: [""],
      rent_years_num: [""],
      indoor_area: [""],
      outdoor_area: [""],
      annual_increase_rate: [""],
      taxes_percentage: [""],
      insurance_period: [""],
      installment_interval: [""],
      indoor_meter_maintenance: [""],
      outdoor_meter_maintenance: [""],
      maintenance_interval: [""],
      grace_period: [""],
      tax_card_number: [""],
      water_status: [""],
      electricity_status: [""],
      elevator_cards: [""],
      locker_number: [""],
      golf_car_service: [""],
      air_conditioning_space: [""],
      marketing_fees: [""],
      sales_differences: [""],
      finishing_insurance: [""],
      indoor_meter_fees: [""],
      outdoor_meter_fees: [""],
      maintenance_indoor_meter_fees: [""],
      maintenance_outdoor_meter_fees: [""],
      marketing_fees_months: [""],
      revenue_share_percentage: [""],
      is_overseas: ["", Validators.required],
      finishing_type_id: ["", Validators.required],
      lead_is_residence: [],
      lead_residence_image: [""],
      lead_residence_name: [""],
      lead_source: [""],
      hold_id: [""],
      serial: [null],
      cash_price: [""],
      generator_type: [""],
      installments_count: [""],
      down_payment_type: [""],
      amount: [""],
      down_payment_interval: [""],
      interval: [""],
      starting_date: [""],
      down_payment_count: [""],
      first_installment_date: [""],
      status: [""],
      build_area: [""],
      maintenance_fees_date: [""],
      garage_fees_date: [""],
    });

    const generatorTypeControl = this.documentForm.get("generator_type");
    if (generatorTypeControl) {
      generatorTypeControl.valueChanges.subscribe(() => {
        this.updatePaymentPlanValidators();
      });
    }
    this.updatePaymentPlanValidators();
  }

  onDownPaymentCountChange = () => {
    this.syncDownPaymentsArray();
    this.calculateFirstInstallmentDate();
  };

  getBanks() {
    this.projectService.getBanks().subscribe(
      (res: any) => {
        this.banks = res || [];
      },
      (err) => {
        console.log(err);
      }
    );
  }

  onPaymentMethodChange(event: any) {
    const methodId = event && event.id !== undefined ? event.id : event;
    const chequeFields = [
      "cheque_book_name",
      "cheque_number",
      "bank_id",
      "name_on_cheques",
      "due_date",
    ];

    chequeFields.forEach((field) => {
      const control = this.documentForm.get(field);
      if (Number(methodId) === 4) {
        control.setValidators(Validators.required);
      } else {
        control.clearValidators();
      }
      control.updateValueAndValidity();
    });

    if (Number(methodId) !== 4) {
      this.documentForm.patchValue({
        cheque_book_name: "",
        cheque_number: "",
        bank_id: null,
        name_on_cheques: "",
        due_date: "",
      });
    }
  }

  onDownPaymentIntervalChange = () => {
    this.calculateFirstInstallmentDate();
  };

  onStartingDateChange = () => {
    this.calculateFirstInstallmentDate();
  };

  onIntervalChange = (event) => {
    console.log("Interval changed to:", event);
    this.calculateFirstInstallmentDate();
  };

  calculateFirstInstallmentDate() {
    const baseDateInput = this.documentForm.value.starting_date;
    const baseDate = baseDateInput
      ? startOfDay(parseISO(baseDateInput))
      : startOfDay(new Date());

    if (!isValid(baseDate)) {
      return;
    }

    const fallbackIntervalMonths = this.resolveIntervalMonths(
      this.documentForm.value.down_payment_interval,
      this.resolveIntervalMonths(
        this.documentForm.value.interval,
        Number(this.defaultDownPaymentInterval)
      )
    );

    if (!fallbackIntervalMonths) {
      return;
    }

    const installmentIntervalMonths = this.resolveIntervalMonths(
      this.documentForm.value.interval,
      fallbackIntervalMonths
    );

    const totalDownPaymentDurationMonths = this.getTotalDownPaymentDuration(
      fallbackIntervalMonths
    );

    const firstInstallmentDate = addDays(
      addMonths(
        baseDate,
        totalDownPaymentDurationMonths + installmentIntervalMonths
      ),
      this.firstInstallmentDayIncrement
    );

    this.documentForm.value.first_installment_date = format(firstInstallmentDate, "yyyy-MM-dd");
  }

  private resolveIntervalMonths(rawInterval: any, fallback: number): number {
    const parsedInterval = Number(rawInterval);
    if (Number.isFinite(parsedInterval) && parsedInterval > 0) {
      return parsedInterval;
    }
    return Number.isFinite(fallback) && fallback > 0 ? fallback : 0;
  }


  private syncDownPaymentsArray() {
    const count = Number(this.documentForm.value.down_payment_count) || 0;
    if (count <= 0 || this.documentForm.value.generator_type !== "PV Calculator") {
      this.down_payments_array = [];
      return;
    }
    const existing: DownPaymentEntry[] = [...this.down_payments_array];
    const defaultInterval = this.documentForm.value.interval || this.defaultDownPaymentInterval;
    this.down_payments_array = Array.from({ length: count }, (_, idx) => {
      const current: DownPaymentEntry = existing[idx] || this.defaultDownPayment;
      return {
        down_payment_type: current.down_payment_type || "percentage",
        down_payment: current.down_payment || null,
        down_payment_interval: current.down_payment_interval || defaultInterval,
      };
    });
  }

  private buildDownPaymentsPayload() {
    return (this.down_payments_array || []).map((payment) => ({
      down_payment_type: payment.down_payment_type || null,
      down_payment:
        payment.down_payment !== null && payment.down_payment !== undefined
          ? Number(payment.down_payment)
          : null,
      down_payment_interval:
        payment.down_payment_interval !== null &&
          payment.down_payment_interval !== undefined
          ? Number(payment.down_payment_interval)
          : null,
    }));
  }

  private getTotalDownPaymentDuration(fallbackIntervalMonths: number): number {
    if (
      this.documentForm.value.generator_type === "PV Calculator" &&
      this.down_payments_array.length
    ) {
      return this.down_payments_array.reduce((total, payment) => {
        const intervalMonths = this.resolveIntervalMonths(
          payment.down_payment_interval,
          fallbackIntervalMonths
        );
        return total + intervalMonths;
      }, 0);
    }

    const downPaymentCount = Number(this.documentForm.value.down_payment_count) || 0;
    if (downPaymentCount <= 0) {
      return 0;
    }

    const downPaymentIntervalMonths = this.resolveIntervalMonths(
      this.documentForm.value.down_payment_interval,
      fallbackIntervalMonths
    );

    return downPaymentIntervalMonths * downPaymentCount;
  }

  get generator_type() {
    return this.documentForm.get("generator_type").value;
  }

  get down_payment_type() {
    return this.documentForm.get("down_payment_type").value;
  }

  get can_add_residence() {
    if (
      this.documentForm.get("is_overseas").value == 1 &&
      this.documentForm.get("lead_is_residence").value == 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  onResidenceChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        // this.documentForm.get('image').setValue({
        //   filename: file.name,
        //   filetype: file.type,
        //   value: ((reader.result as any) as any).split(',')[1]
        // });
        let value = (reader.result as any as any).split(",")[1];
        this.documentForm.get("lead_residence_image").patchValue(value);
        this.documentForm.get("lead_residence_name").patchValue(file.name);
      };
    }
  }

  onOverSeaChange(event) {
    console.log(event);
    console.log(this.documentForm.get("is_overseas").value);
    console.log(this.documentForm.get("lead_is_residence").value);
    console.log(this.can_add_residence);
  }

  submit() {
    let formModel = this.documentForm.value;
    console.log(this.documentForm.value);
    console.log(this.documentForm.valid);
    const chequeDetailsMissing =
      Number(formModel.payment_method_id) === 4 &&
      (!formModel.cheque_book_name ||
        !formModel.cheque_number ||
        !formModel.bank_id ||
        !formModel.name_on_cheques ||
        !formModel.due_date);

    if (!formModel.payment_method_id) {
      this.documentForm.get("payment_method_id").markAsTouched();
      swal("Please select a payment method.", "", "warning");
      return;
    } else if (chequeDetailsMissing) {
      [
        "cheque_book_name",
        "cheque_number",
        "bank_id",
        "name_on_cheques",
        "due_date",
      ].forEach((name) => this.documentForm.get(name).markAsTouched());
      swal("Please complete all cheque book details.", "", "warning");
      return;
    } else if (formModel.lead_id == 0) {
      swal("Please assign lead to reservation.", "", "warning");
    } else if (!formModel.lead_name) {
      swal(
        "Get Lead Info!",
        "Make sure assigning lead to reservation by getting its info!",
        "warning"
      );
    } else if (!formModel.is_overseas) {
      swal("Please Select Is Overseas!", "", "warning");
    } else {
      this.slimLoadingBarService.start(() => {
        console.log("Loading complete");
      });
      formModel.reservation_fees = formModel.reservation_fees + " % ";
      this.disabledSubmitWhileSending = true;
      this.checkValidate();
      if (this.isHold) {
        formModel.hold_id = this.holdId;
      }
      if (this.eoi_id) {
        formModel.eoi_id = this.eoi_id;
      }

      if (this.can_add_residence && !formModel.lead_residence_image) {
        swal("Please Upload Residence Image!", "", "warning");
        this.disabledSubmitWhileSending = false;
        return;
      }
      if (
        !formModel.partner_broker_id &&
        this.unit_details &&
        this.unit_details.project &&
        this.unit_details.project.partner_broker_id
      ) {
        formModel.partner_broker_id = this.unit_details.project.partner_broker_id;
      }
      this.addReservation.postReservation(formModel).subscribe(
        (data) => {
          console.log(data);
          swal(
            "Cool!",
            "Reservation is added successfully, pending accountant approve!",
            "success"
          );
          this.router.navigate(["/pages/sold-units"]);
          this.slimLoadingBarService.complete();
          this.disabledSubmitWhileSending = false;
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
          this.disabledSubmitWhileSending = false;
        }
      );
    }
  }

  checkValidate() {
    const invalid = [];
    const controls = this.documentForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log(invalid);
    return {
      can_submit: invalid.length <= 0,
      errors: invalid,
    };
  }

  blocktimeEnd() {
    swal("Temp Block time has finished", "", "warning");
    // this.router.navigate(["/pages/projects"]);
  }

  channels: any[] = [];
  leadSources = [];

  require_channels = [];
  getChannels() {
    this.slimLoadingBarService.start();
    this.marketingService.getChannels().subscribe(
      (res: any) => {
        this.channels = Array.isArray(res) ? res : [];
        if (Array.isArray(this.require_channels)) {
          this.require_channels.forEach((callback) => callback());
        }
        this.require_channels = null;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  deal_type_change() {
    this.documentForm.get("deal_type").valueChanges.subscribe((val) => {
      console.log(`-------------------${val}`);
      if (Array.isArray(this.require_channels)) {
        this.require_channels.push(() => {
          this.channels.forEach((e) => {
            if (e.name == val) {
              this.leadSources = e.sources;

              if (val == "Direct") {
                this.documentForm.get("lead_source").setValue("");
                this.documentForm.get("broker_id").setValue("");
                this.documentForm.get("ambassador_id").setValue("");
                this.documentForm.get("broker_incentive_id").setValue("");
              } else if (val == "In-Direct") {
                this.documentForm.get("deal_category").setValue("");
              }
            }
          });
        });
      } else {
        this.channels.forEach((e) => {
          if (e.name == val) {
            this.leadSources = e.sources;

            if (val == "Direct") {
              this.documentForm.get("lead_source").setValue("");
              this.documentForm.get("broker_id").setValue("");
              this.documentForm.get("ambassador_id").setValue("");
              this.documentForm.get("broker_incentive_id").setValue("");
            } else if (val == "In-Direct") {
              this.documentForm.get("deal_category").setValue("");
            }
          }
        });
      }
    });

    this.documentForm.get("lead_source").valueChanges.subscribe((val) => {
      if (val == "Ambassador") {
        this.documentForm.get("broker_id").setValue("");
        this.documentForm.get("broker_incentive_id").setValue("");
      } else if (val == "Broker") {
        this.documentForm.get("ambassador_id").setValue("");
        this.documentForm.get("broker_incentive_id").setValue("");
      }
    });
  }

  getAmbassadors() {
    let params = {
      paginate: false,
    };
    this.slimLoadingBarService.start();
    this.userService.getAmbasdors(params).subscribe(
      (data: any) => {
        this.ambassadors = Array.isArray(data) ? data : [];
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getBrokers() {
    this.slimLoadingBarService.start();
    this.userService.getBorkers().subscribe(
      (data: any) => {
        this.brokers = Array.isArray(data) ? data : [];
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getPartnerBrokers() {
    this.slimLoadingBarService.start();
    this.userService
      .getBorkers({ is_select_form: true, is_partner: true })
      .subscribe(
        (data: any) => {
          this.partner_brokers = data || [];
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  search(event) {}

  onContractTypeChange(value) {
    this.ready_to_add_contract_sale = false;
    this.ready_to_add_contract_rent = false;
    console.log(value);
    if (value == "rent") {
      this.payment_plan_id = null;
      // this.documentForm.patchValue({
      //   payment_type: '',
      //   is_overseas: '',
      //   reservation_fees: '',
      //   installment_fees: '',
      //   payment_plan_id: '',
      // });
      this.documentForm.removeControl("payment_type");
      this.documentForm.removeControl("is_overseas");
      this.documentForm.removeControl("reservation_fees");
      // this.documentForm.removeControl("installment_fees");
      this.documentForm.removeControl("payment_plan_id");

      this.documentForm.addControl(
        "rent_value",
        new FormControl("", Validators.required)
      );
      this.documentForm.addControl(
        "rent_start_date",
        new FormControl("", Validators.required)
      );
      this.documentForm.addControl(
        "rent_end_date",
        new FormControl("", Validators.required)
      );
      this.documentForm.addControl(
        "rent_years_num",
        new FormControl("", Validators.required)
      );
      this.ready_to_add_contract_rent = true;
    } else if (value == "sale") {
      this.documentForm.removeControl("rent_value");
      this.documentForm.removeControl("rent_start_date");
      this.documentForm.removeControl("rent_end_date");
      this.documentForm.removeControl("rent_years_num");

      this.documentForm.addControl(
        "payment_type",
        new FormControl("", Validators.required)
      );
      this.documentForm.addControl(
        "is_overseas",
        new FormControl("", Validators.required)
      );
      this.documentForm.addControl(
        "reservation_fees",
        new FormControl("", Validators.required)
      );
      // this.documentForm.addControl(
      //   "installment_fees",
      //   new FormControl("", Validators.required)
      // );
      this.documentForm.addControl(
        "payment_plan_id",
        new FormControl("", Validators.required)
      );
      this.ready_to_add_contract_sale = true;
    }

    this.updatePaymentPlanValidators();
  }

  private updatePaymentPlanValidators() {
    const paymentPlanControl = this.documentForm.get("payment_plan_id");
    if (!paymentPlanControl) {
      return;
    }
    const isPvCalculator =
      this.documentForm.get("generator_type").value === "PV Calculator";

    if (isPvCalculator) {
      paymentPlanControl.clearValidators();
    } else {
      paymentPlanControl.setValidators(Validators.required);
    }
    paymentPlanControl.updateValueAndValidity({ emitEvent: false });
  }

  get current_contract_type(): String {
    return this.documentForm.get("contract_type").value;
  }

  onFinishTypePriceChange(event: any) {
    const finishingTypes = Array.isArray(this.unit_details.finishing_types)
      ? this.unit_details.finishing_types
      : [];
    const id =
      typeof event === "object" && event
        ? event.id != null
          ? event.id
          : event.value != null
          ? event.value
          : null
        : event;
    if (id == null || id === "") {
      this.documentForm.patchValue({
        unit_price: null,
      });
      return;
    }
    const selectedType = finishingTypes.find((type) => type.id == id);
    if (selectedType.pivot.price != null) {
      this.documentForm.patchValue({
        unit_price: selectedType.pivot.price,
      });
    }
    if (this.unit_details.project.id) {
      let payload = {
        project_id: this.unit_details.project.id,
        phase_id: this.unit_details.phase_id,
        finishing_type_id: id,
      };
      this.getPaymentTermsByProjectId(payload);
    }
  }

  validateNumberParkingSlots(event: KeyboardEvent) {
    console.log(event);
    console.log(this.unit_details);
    // if (event.target)
    const val = this.documentForm.get("unit_garage_slots").value;
    console.log(val);
    if (+val > this.unit_details.project.available_parking_slots) {
      event.preventDefault();
      this.documentForm.patchValue({
        unit_garage_slots: this.unit_details.project.available_parking_slots,
      });
    }
  }

  validateNumberStorageSlots(event: KeyboardEvent) {
    const val = this.documentForm.get("storage_slots").value;
    console.log(val);
    if (+val > this.unit_details.project.available_storage_slots) {
      event.preventDefault();
      this.documentForm.patchValue({
        storage_slots: this.unit_details.project.available_storage_slots,
      });
    }
  }

  validateExtraOutdoorMeter(event: KeyboardEvent): void {
    const val = this.documentForm.get("extra_outdoor_meters").value;
    console.log(val);
    if (+val > this.unit_details.project.available_extra_outdoor_meters) {
      event.preventDefault();
      this.documentForm.patchValue({
        extra_outdoor_meters:
          this.unit_details.project.available_extra_outdoor_meters,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/reservation/addreservation/addreservation.component.ts